module.exports = MaterialUI.InputAdornment;